interface Map {
  [key: string]: any;
  [index: number]: any;
}

// export const TAB_GENERAL = 'general';
export const TAB_SALARY_AND_WELFARE = 'salary';
export const TAB_JOB_FUTURE = 'future';
export const TAB_CITY_COMPARISON = 'city';

// export const TAB_HOT_JOBS = 'hot_jobs';
// export const TAB_JOB_REQUIREMENT = '4';
// export const TAB_DISTRICT_ANALYSIS = '5';

export const TAB_MAP: Map = {
  // [TAB_GENERAL]: '综合概况',
  [TAB_SALARY_AND_WELFARE]: '薪资福利',
  [TAB_JOB_FUTURE]: '就业前景',
  [TAB_CITY_COMPARISON]: '城市对比',
  // [TAB_HOT_JOBS]: '热招职位',
  // [TAB_JOB_REQUIREMENT]: '任职要求',
  // [TAB_DISTRICT_ANALYSIS]: '区域分析',
};
export const WORK_EXPERIENCE_NONE = 'work_experience_none';
export const WORK_EXPERIENCE_0 = 'work_experience_0';
export const WORK_EXPERIENCE_1_3 = 'work_experience_1_3';
export const WORK_EXPERIENCE_3_5 = 'work_experience_3_5';
export const WORK_EXPERIENCE_5_10 = 'work_experience_5_10';
export const WORK_EXPERIENCE_10_PLUS = 'work_experience_10_plus';

export const WORK_EXPERIENCE_ARRAY = [
  WORK_EXPERIENCE_0,
  WORK_EXPERIENCE_1_3,
  WORK_EXPERIENCE_3_5,
  WORK_EXPERIENCE_5_10,
  WORK_EXPERIENCE_10_PLUS,
  WORK_EXPERIENCE_NONE,
];

export const WORK_EXPERIENCE_MAP: Map = {
  [WORK_EXPERIENCE_0]: '应届',
  [WORK_EXPERIENCE_1_3]: '1-3年',
  [WORK_EXPERIENCE_3_5]: '3-5年',
  [WORK_EXPERIENCE_5_10]: '5-10年',
  [WORK_EXPERIENCE_10_PLUS]: '>10年',
  [WORK_EXPERIENCE_NONE]: '不限经验',
};

export const WORK_EXPERIENCE_CITY_MAP: Map = {
  [WORK_EXPERIENCE_0]: '1年以内',
  [WORK_EXPERIENCE_1_3]: '1-3年',
  [WORK_EXPERIENCE_3_5]: '3-5年',
  [WORK_EXPERIENCE_5_10]: '5-10年',
  [WORK_EXPERIENCE_10_PLUS]: '>10年',
  [WORK_EXPERIENCE_NONE]: '不限经验',
};

export const WORK_EXPERIENCE_BENEFITS_SEO_MAP: Map = {
  [WORK_EXPERIENCE_0]: '没有经验的应届生',
  [WORK_EXPERIENCE_1_3]: '有1到3年工作经验的人群',
  [WORK_EXPERIENCE_3_5]: '有3到5年工作经验的人群',
  [WORK_EXPERIENCE_5_10]: '有5到10年工作经验的人群',
  [WORK_EXPERIENCE_10_PLUS]: '有十年以上工作经验的人群',
  [WORK_EXPERIENCE_NONE]: '不限工作经验的人群',
};

export const WORK_EXPERIENCE_FUTURE_SEO_MAP: Map = {
  [WORK_EXPERIENCE_0]: '应届生',
  [WORK_EXPERIENCE_1_3]: '工作年限1到3年的人群',
  [WORK_EXPERIENCE_3_5]: '工作年限3到5年的人群',
  [WORK_EXPERIENCE_5_10]: '工作年限5到10年的人群',
  [WORK_EXPERIENCE_10_PLUS]: '工作年限10年以上的人群',
  [WORK_EXPERIENCE_NONE]: '不限工作年限的人群',
};

export const WORK_EXPERIENCE_CITY_SEO_MAP: Map = {
  [WORK_EXPERIENCE_0]: '对于工作经验1年以内职位的需求量',
  [WORK_EXPERIENCE_1_3]: '对于1-3年工作经验的职位需求量',
  [WORK_EXPERIENCE_3_5]: '对于3-5年工作经验的职位需求量',
  [WORK_EXPERIENCE_5_10]: '对于5-10年工作经验的职位需求量',
  [WORK_EXPERIENCE_10_PLUS]: '对于10年及以上工作经验的职位需求量',
  [WORK_EXPERIENCE_NONE]: '对于不限工作经验的职位需求量',
};

export const EDUCATION_NONE = 'education_none';
export const EDUCATION_COLLEGE = 'education_college';
export const EDUCATION_BACHELOR = 'education_bachelor';
export const EDUCATION_MASTER = 'education_master';
export const EDUCATION_DOCTOR = 'education_doctor';

export const EDUCATION_MAP: Map = {
  [EDUCATION_COLLEGE]: '专科',
  [EDUCATION_BACHELOR]: '本科',
  [EDUCATION_MASTER]: '硕士',
  [EDUCATION_DOCTOR]: '博士',
  [EDUCATION_NONE]: '不限学历',
};

export const EDUCATION_BENEFITS_SEO_MAP: Map = {
  [EDUCATION_COLLEGE]: '专科学历的',
  [EDUCATION_BACHELOR]: '本科学历的',
  [EDUCATION_MASTER]: '硕士学历的',
  [EDUCATION_DOCTOR]: '博士学历的',
  [EDUCATION_NONE]: '不限学历的人群',
};

export const SALARY_RANGES = ['0-8k', '8-15k', '15-30k', '>30k'];

export const RATING_JOB_DIFFICULTY = '0';
export const RATING_JOB_FUTURE = '1';
export const RATING_JOB_CHALLENGE = '2';

export const RATING_NAME_MAP: Map = {
  [RATING_JOB_DIFFICULTY]: '上手难度',
  [RATING_JOB_FUTURE]: '发展前景',
  [RATING_JOB_CHALLENGE]: '工作挑战',
};

export const SKILL_TYPE_BASIC = 'basic';
export const SKILL_TYPE_ADVANCE = 'advance';

export const SKILL_MAP: Map = {
  [SKILL_TYPE_BASIC]: '基础技能',
  [SKILL_TYPE_ADVANCE]: '高级技能',
};

export const COMPETITIVE_SCORE_INTRO =
  '0.3*MinMax（平均薪资）+0.6*MinMax（职位开放数增长率）+0.1*MinMax（生活成本）';

export const STORAGE_KEY_VALUE = 'jobTitleValue';
